/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconAlertSmall = createReactComponent("alert-small", "IconAlertSmall", [
  ["path", { d: "M12 8v4", key: "svg-0" }],
  ["path", { d: "M12 16h.01", key: "svg-1" }]
]);

export { IconAlertSmall as default };
//# sourceMappingURL=IconAlertSmall.js.map
